import { AnyAction, Dispatch } from 'redux';

import { CAMPAIGN_ROOT_REGION_ID, CAMPAIGN_SELECTED_ROOT_REGION } from 'utils/constants/campaign';

import { AdditionalDefault, TreeCollection } from '@hh.ru/magritte-ui';

import { OnChangeUpdater } from 'components/common/CompositeSelection/contexts';

import { setIsRootRegionSelected } from 'store/models/createCampaign';

/**
 * Утилита для выбора региона в дереве через Suggest,
 * рассчитывает, включать или исключать выбранный регион в зависимости от уже выбранных регионов и исключенных регионов
 * @param collection - коллекция регионов
 * @param inputValue - значение в поле ввода
 * @param value - выбранные регионы
 * @param excludedValue - исключенные регионы
 * @param onChange - функция для обновления регионов
 * @param dispatch - функция для диспатча экшенов
 */
export const handleOnSelectValidator = (
    collection: TreeCollection<AdditionalDefault>,
    inputValue: string,
    value: string[],
    excludedValue: string[] | undefined,
    onChange: (updater: OnChangeUpdater) => void,
    dispatch: Dispatch<AnyAction>
): boolean => {
    const foundItem = collection.getModel(inputValue);
    if (foundItem) {
        if (foundItem.id === CAMPAIGN_ROOT_REGION_ID) {
            onChange((prev) => ({ ...prev, value: CAMPAIGN_SELECTED_ROOT_REGION }));
            dispatch(setIsRootRegionSelected(true));
        } else if (collection.getParentIds(foundItem.id).some((id) => value.includes(id))) {
            const parentId = collection.getParentId(foundItem.id);
            const childrenIds = collection.getChildrenIds(foundItem.id);

            if (parentId && excludedValue?.includes(parentId)) {
                onChange((prev) => ({ ...prev, value: [...value, foundItem.id], excludedValue }));
            } else if (childrenIds.some((id) => excludedValue?.includes(id))) {
                onChange((prev) => ({
                    ...prev,
                    value: [...value, foundItem.id],
                    excludedValue: [...(excludedValue ?? []).filter((id) => !childrenIds.includes(id)), foundItem.id],
                }));
            } else {
                onChange((prev) => ({
                    ...prev,
                    value: [...value, foundItem.id],
                    excludedValue: [...(excludedValue ?? []), foundItem.id],
                }));
            }
        } else {
            const newIds = value.includes(foundItem.id) ? value : [...value, foundItem.id];
            onChange((prev) => ({ ...prev, value: newIds, excludedValue }));
        }
        return true;
    }
    return false;
};
